import React, { useState, useEffect, useRef } from "react";
import FormTextField from "../../components/general/FormTextField";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import { playNotificationSound } from "../../functions/generalFunctions";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Col,
  Drawer,
  Tabs,
  Row,
  Table,
  Collapse,
  Button,
  message,
  Badge,
  Tag,
  Modal,
  Input,
  Typography,
} from "antd";
import { EyeOutlined, LoadingOutlined, BellOutlined, CommentOutlined } from "@ant-design/icons";
// import { Button, Spin } from "antd";
import FormSelect from "../../components/general/FormSelect";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import FormButton from "../../components/general/FormButton";
import { postRequest } from "../../services/mainApp.service";
import { getTime } from "../../functions/dateFunctions";
import ViewOrderModal from "../../components/PosComponentsFood/ViewOrderModal";
import { itemDetail } from "./ItemDetail";
const { Panel } = Collapse;
import { Popover } from "antd";
import NewOrdersModal from "../../components/PosComponentsFood/NewOrdersModal";
import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";
import { useNavigate } from "react-router-dom";
import ComplaintManagementModal from "../PointOfSale/Food/ComplaintManagementModal";
import { AGENT, CALL_CENTER_ADMIN, BRANCH_ADMIN, CASHIER } from "../../common/SetupMasterEnum";
import { RestrictBranchToChangeOrderStatus } from "../../utils/PosSettingConstants";
import { useCheckPosSetting } from "../../customHooks/PosCustomHooks";

const ExportExcelButton = ({ dataSource }) => {
  const exportToExcel = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "order_data_export";

    // Prepare data for export, including handling the Action column
    const exportData = dataSource.map((item) => {
      // Create a new object to avoid mutating original data
      const exportItem = {
        OrderNumber: item.OrderNumber,
        BranchName: item.BranchName,
        PhoneNumber: item.PhoneNumber,
        CustomerName: item.CustomerName,
        OrderDateTime: item.OrderDateTime,
        OrderDeliveryDateTime: item.OrderDeliveryDateTime,
        TotalAmountWithGST: item.TotalAmountWithGST,
        RiderName: item.RiderName,
        DeliveryTime: item.DeliveryTime,
        OrderSourceValue: item.OrderSourceValue,
        OrderStatus: item.OrderStatus,
      };

      return exportItem;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(data, fileName + fileExtension);
  };

  return (
    <Button
      style={{
        color: "white",
        backgroundColor: "#017971",
        borderRadius: "5px",
      }}
      onClick={exportToExcel}
    >
      Export to Excel
    </Button>
  );
};

function Podms() {

  const dispatch = useDispatch();

  const [allOrders, setAllOrders] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [isAllOrders, setIsAllOrders] = useState(true);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [orderSourceList, setOrderSourceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewOrderData, setViewOrderData] = useState(null);
  const [viewOrder, setViewOrder] = useState(false);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [riders, SetRiders] = useState([]);

  // new Orders data
  const [newOrders, setNewOrders] = useState([]);
  const [recallData, setRecallData] = useState(null);
  const [recallModalVisible, setRecallModalVisible] = useState(false);

  const [NewviewOrder, setNewViewOrder] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState({});
  const [popoverData, setPopoverData] = useState({});


  //  Redux
  const userData = useSelector((state) => state.authReducer);


  const { userBranchList } = useSelector((state) => state.authReducer);
  const { selectedOrder, cancelOrderStatusObj, FromDate, ToDate, controller } =
    useSelector((state) => state.PointOfSaleReducer);

  const {
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);

  const BASE_URL = process.env.REACT_APP_BASEURL;

  const [data, setData] = useState({
    areaId: null,
    StatusId: null,
    orderNumber: null,
    CustomerId: null,
    customerName: "",
    CustomerPhone: null,
    cityId: null,
    DateFrom: "",
    DateTo: "",
  });

  const { RefreshStats } = useSelector((state) => state.RefreshReducer);
  const navigate = useNavigate();

  const [complainModalRowData, setComplainModalRowData] = useState({});
  const [complainTypeDropDownData, setComplainTypeDropDownData] = useState([]);
  const [complainCatDropDownData, setComplainCatDropDownData] = useState([]);
  const [complainStatusHistory, setComplainStatusHistory] = useState([]);
  const [complaintStatusDropDownData, setComplaintStatusDropDownData] =
    useState([]);
  const [isComplainModalVisible, setIsComplainModalVisible] = useState(false);
  const [isAlreadyTransfered, setIsAlreadyTransfered] = useState(false);
  const [isSearchPanelCollapsed, setIsSearchPanelCollapsed] = useState(false);
  const restrictBranchToChangeOrderStatus = useCheckPosSetting(RestrictBranchToChangeOrderStatus);

  // A function to map PaymentTypeId to PaymentMode
  const getPaymentMode = (paymentTypeId) => {
    const paymentType = paymentTypeList.find(
      (type) => type.PaymentModeId === paymentTypeId
    );
    return paymentType ? paymentType.PaymentMode : "Unknown";
  };

  // Map statuses to styles for UI/UX clarity
  const statusColors = {
    Pending: "orange",
    Confirmed: "blue",
    Process: "cyan",
    Dispatch: "purple",
    Delivered: "green",
    Cancel: "red",
    Paid: "gold",
    Ready: "lime",
  };

  const columns = [
    {
      title: "Order Number",
      dataIndex: "OrderNumber",
      key: "OrderNumber",
      render: (text, item) => (
        <>
          <Button ghost type="primary"
            onClick={() => {

              (userData?.RoleId === AGENT &&
                ((!item?.IsCancelable && !item?.IsClosed && !item?.IsHandOverToCustomer &&
                  !item.IsCustomerNotResponding && !item?.IsBranchTransfer) || item?.IsHold)) ?
                navigate('/orderBooking', {
                  state: { order: item }
                }) :
                message.error("This order cannot be recalled.")
            }
            }
          >
            {
              item?.OrderNumber
            }
          </Button>
        </>
      ),
    },
    {
      title: "Branch",
      dataIndex: "BranchName",
      key: "BranchName",
    },
    {
      title: "Phone",
      dataIndex: "PhoneNumber",
      key: "PhoneNumber",
    },
    {
      title: "Customer Name",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },
    {
      title: "Order Date Time",
      dataIndex: "OrderDateTime",
      key: "OrderDateTime",
    },
    {
      title: "Delivery Date Time",
      dataIndex: "OrderDeliveryDateTime",
      key: "OrderDeliveryDateTime",
    },
    {
      title: "Waiter / Rider",
      dataIndex: "WaiterRiderName",
      key: "WaiterRiderName",
      render: (text, record) => {
        if (record.OrderModeId === 109) {
          return record.WaiterName || "-";
        } else {
          return record.RiderName || "-";
        }
      },
    },
    {
      title: "Amount",
      dataIndex: "TotalAmountWithGST",
      key: "TotalAmountWithGST",
      render: (text, record) => {

        return record.TotalAmountWithGST.toFixed(2);

      },
    },
    {
      title: "Payment Mode",
      dataIndex: "PaymentMode",
      key: "PaymentMode",
      render: (text, record) => {
        if (record.PaymentTermName) {
          return record.PaymentTermName;
        } else {
          return record.PaymentMode;
        }
      },
    },
    // {
    //   title: "Delivery Time(Mins)",
    //   dataIndex: "DeliveryTime",
    //   key: "DeliveryTime",
    // },
    {
      title: "Order Source",
      dataIndex: "OrderSourceValue",
      key: "OrderSourceValue",
    },
    {
      title: "Status",
      dataIndex: "OrderStatus",
      key: "OrderStatus",
      render: (status) => (
        <Tag color={statusColors[status] || "default"}>{status}</Tag>
      ),
    },
    {
      title: "Action",
      dataIndex: "x",
      key: "x",
      render: (text, item) => (
        <>
          <Button type="text" onClick={() => getOrderDetail(item)}>
            <EyeOutlined />
          </Button>
          <Button
            type="text"
            onClick={() => {

              setIsComplainModalVisible(true);
              setComplainModalRowData({ selectedOrder: item });

              setComplainStatusHistory(supportingTable?.Table3 ?? []);
              setComplaintStatusDropDownData(supportingTable?.Table4 ?? []);

            }
            }>
            <CommentOutlined />
          </Button>
          <ViewOrderModal
            data={viewOrderData}
            viewOrder={viewOrder}
            toggleViewOrder={toggleViewOrder}
            isMainPage={(userData.RoleId == AGENT && !isAlreadyTransfered) ? false : true}
            // isMainPage={true}
            ridersData={riders}
            branchList={branchList}
            fetchLatestOrders={fetchDataFromApi}
            allowStatusChange={userData.RoleId == CALL_CENTER_ADMIN ? true : !restrictBranchToChangeOrderStatus}
          />

          {

            <ComplaintManagementModal
              isComplainModalVisible={isComplainModalVisible}
              closeModal={closeModal}
              saveComplaint={saveComplaint}
              modalData={complainModalRowData}
              complainTypeDropDownData={complainTypeDropDownData}
              complainCatDropDownData={complainCatDropDownData}
              complainStatusHistory={complainStatusHistory}
              complaintStatusDropDownData={complaintStatusDropDownData}
            />

          }
        </>
      ),
    },
  ];

  const closeModal = () => {
    setIsComplainModalVisible(false);
  };

  const saveComplaint = (editedFields) => {
    // if (editedFields.ComplainStatusId === null || editedFields.Remarks === "") {
    //   message.error("Complaint status Or remarks cant be empty");
    //   return;
    // }

    postRequest(
      "/CrudComplain",
      {
        ...editedFields,
        OperationId: 2,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
        UserIP: "1.2.2.1",
      },
      controller
    ).then((response) => {
      if (response.error === true) {
        message.error(response.errorMessage);
        return;
      }
      if (response.data.response === false) {
        message.error(response.DataSet.Table.errorMessage);
        return;
      }
      dispatch({
        type: RESET_FORM_FIELD,
        payload: { initialValue: {}, listItem: response.data.DataSet.Table1 },
      });
      updateSuppTable(response.data.DataSet);
    });

    setIsModalVisible(false);
  };

  const initialFormValues = {
    BranchId: null,
    AreaId: null,
    OrderNumber: "",
    CustomerId: null,
    CustomerName: "",
    CustomerPhone: "",
    OrderModeId: null,
    OrderSourceId: null,
    DateFrom: "",
    DateTo: "",
    StatusId: null,
    CityId: null,
  };

  // HANDLE SEARCH SUBMIT
  const [filteredData, setFilteredData] = useState([]);


  const [searchFields, setSearchFields] = useState({
    BranchId: null,
    AreaId: null,
    OrderNumber: "",
    CustomerId: null,
    CustomerName: "",
    CustomerPhone: "",
    OrderModeId: null,
    OrderSourceId: null,
    DateFrom: null,
    DateTo: null,
    StatusId: null,
  });

  const DateRefFrom = useRef({});
  const DateRefTo = useRef({});


  const fetchDataFromApi = () => {
    setLoading(true);
    postRequest("GetOrder", {
      OperationId: 1,
      UserIP: "12.1.1.2",
      BranchId:
        selectedOrder?.BranchId || userBranchList.length === 1
          ? userBranchList[0].BranchId
          : null,
      AreaId: searchFields?.AreaId,
      StatusId: searchFields.StatusId,
      OrderNumber: searchFields.OrderNumber || "%%",
      CustomerName: searchFields.CustomerName || "%%",
      CustomerPhone: searchFields.CustomerPhone || "%%",
      DateFrom: searchFields.DateFrom || null,
      DateTo: searchFields.DateTo || null,
      CityId: userBranchList[0]?.CityId,
      CompanyId: userData.CompanyId,
      userId: userData.UserId,
      OrderModeId: searchFields.OrderModeId || null,
      OrderSourceId: searchFields.OrderSourceId || null,
    })
      .then((response) => {
        setLoading(false);
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
        const { Table2, Table3, Table4, Table7, Table10, Table, Table13, Table14, Table5, Table6 } = data;
        SetRiders(data || []);
        setNewOrders(Table13 || []);
        setFilteredData(Table || []);
        setOrderStatusList(Table2 || []);
        setAllOrders(Table || []);
        setBranchList(Table3 || []);
        setAreaList(Table4 || []);
        setPaymentTypeList(Table7 || []);
        setOrderSourceList(Table10 || []);

        setComplainTypeDropDownData(Table5 || []);
        setComplainCatDropDownData(Table6 || []);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    fetchDataFromApi();
  }, []);

  useEffect(() => {

    // console.log('RefreshStats ' + RefreshStats);
    if (RefreshStats == 1) {

      fetchDataFromApi();
      // console.log('RefreshStats ' + RefreshStats);
      dispatch({ type: "REFRESH_STATS", payload: 0 });
    }
  }, [RefreshStats]);

  const fetchNewOrders = () => {
    postRequest("GetOrder", {
      OperationId: 1,
      UserIP: "12.1.1.2",

      BranchId:
        selectedOrder?.BranchId || userBranchList.length === 1
          ? userBranchList[0].BranchId
          : null,
      AreaId: searchFields?.AreaId,
      StatusId: -1,
      OrderNumber: searchFields.OrderNumber || "%%",
      CustomerName: searchFields.CustomerName || "%%",
      CustomerPhone: searchFields.CustomerPhone || "%%",
      DateFrom: null,
      DateTo: null,
      CityId: userBranchList[0]?.CityId,
      CompanyId: userData.CompanyId,
      userId: userData.UserId,
      OrderModeId: searchFields.OrderModeId || null,
      OrderSourceId: searchFields.OrderSourceId || null,
    })
      .then((response) => {
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
        const { Table13 } = data;
        setNewOrders(Table13 || []);


        if (Table13 || [].length > 0) {
          playNotificationSound();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };



  const handleSearchFieldChange = (data) => {
    const { name, value } = data;

    if (
      name === "CustomerName" ||
      name === "CustomerPhone" ||
      name === "OrderNumber"
    ) {
      setSearchFields({ ...searchFields, [name]: value });
    } else if (name === "DateFrom" || name === "DateTo") {
      setSearchFields({ ...searchFields, [name]: value + " 00:00:00.000" });
    } else {
      setSearchFields({ ...searchFields, [name]: value });
    }
  };

  DateRefFrom.current = searchFields.DateFrom;
  DateRefTo.current = searchFields.DateTo;
  /**
   * This function change the state of Select in Search Field
   * @param {{}} data event object of field
   */
  const handleSelectChange = (data) => {
    if (data.value !== null) {
      setSearchFields({ ...searchFields, [data.name]: data.value });
    } else {
      // If the user clears the selection, set the field to null
      setSearchFields({ ...searchFields, [data.name]: null });
    }
  };

  ///      Handle Search Submit ///
  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);


  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // setLoading(true);

    fetchDataFromApi();

  };

  /// Get order Detail
  /// Get order Detail
  const getOrderDetail = (record) => {

    setIsAlreadyTransfered(record?.IsBranchTransfer == true || record?.IsBranchTransfer == 1 ? true : false);

    if (!record || !record?.OrderMasterId) {
      return;
    }

    setViewOrder(true);

    postRequest("getOrderDetail", {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      OrderId: record.OrderMasterId,
      UserId: userData.UserId,
      UserIP: "192.1.1.1",
    })
      .then((response) => {
        setViewOrderData(response.data.DataSet);
      })
      .catch((error) => {
        setViewOrder(false);
        console.error(error);
      });
  };


  //// New API
  const getDetail = (record) => {
    if (!record || !record.OrderMasterId) {
      console.error("OrderMasterId is undefined in the record:", record);
      return;
    }

    setPopoverVisible((prevVisible) => ({
      ...prevVisible,
      [record.OrderMasterId]: true,
    }));

    postRequest("getOrderDetail", {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      OrderId: record.OrderMasterId,
      UserId: userData.UserId,
      UserIP: "192.1.1.1",
    })
      .then((response) => {
        setPopoverData((prevData) => ({
          ...prevData,
          [record.OrderMasterId]: response.data.DataSet,
        }));
      })
      .catch((error) => {
        setPopoverVisible((prevVisible) => ({
          ...prevVisible,
          [record.OrderMasterId]: false,
        }));
        console.error(error);
      });
  };

  // Handle tab change
  const handleTabChange = (key) => {
    setIsAllOrders(false);

    const filteredOrderByStatus = allOrders?.filter(
      (status) => status.OrderStatusId === key
    );

    setFilteredData(filteredOrderByStatus);
  };

  const getOrderStatusCount = (orderStatusId) => {
    if (!Array.isArray(orderStatusList)) {
      throw new Error("orderStatusList must be an array.");
    }

    const filteredList = allOrders.filter(
      (status) => status.OrderStatusId === orderStatusId
    );

    return filteredList.length;
  };

  const toggleNewViewOrder = () => {
    setNewViewOrder(!NewviewOrder);
  };


  const DetailPopover = ({ data }) => {
    return (
      <div style={{ borderRadius: "8px" }}>
        <Table
          size="small"
          columns={[
            {
              title: <span style={{ fontSize: "12px" }}>Product Name</span>,
              dataIndex: "ProductDetailName",
              key: "ProductDetailName",
              className: "custom-header",
            },
            {
              title: <span style={{ fontSize: "12px" }}>Quantity</span>,
              dataIndex: "Quantity",
              key: "Quantity",
              className: "custom-header",
            },
            {
              title: <span style={{ fontSize: "12px" }}>Discount</span>,
              dataIndex: "DiscountPercent",
              key: "DiscountPercent",
              className: "custom-header",
            },
            {
              title: <span style={{ fontSize: "12px" }}>Amount</span>,
              dataIndex: "PriceWithGST",
              key: "PriceWithGST",
              className: "custom-header",
            },
          ]}
          dataSource={
            data?.Table1?.map((item, index) => ({
              key: index,
              ProductDetailName: item.ProductDetailName,
              Quantity: item.Quantity,
              DiscountPercent: item.DiscountPercent,
              PriceWithGST: item.PriceWithGST,
            })) || []
          }
          pagination={false}
          rowClassName={() => "custom-row no-hover"}
        />
      </div>
    );
  };

  function toggleViewOrder() {
    setViewOrder(!viewOrder);
  }

  // Function to get status color based on status name
  const getStatusColor = (statusName) => {
    const status = statusName?.toLowerCase() || "";

    if (status.includes("pending")) {
      return "#ffcccc"; // red
    } else if (status.includes("confirm")) {
      return "#ccffcc"; // green
    } else if (status.includes("dispatch")) {
      return "#ffffcc"; // yellow
    } else if (status.includes("delivered")) {
      return "#ffccff"; // pink
    } else if (status.includes("transfer")) {
      return "#d2b48c"; // brown
    }

    return null; // default color
  };

  // Function to get row style based on status
  const getRowStyle = (record) => {

    const backgroundColor = getStatusColor(record?.OrderStatus);
    return backgroundColor ? { backgroundColor } : {};
  };
  // ...


  return (
    <div
      style={{
        background: "white",
        padding: 15,
        boxShadow: "0 0 5px lightgray",
        borderRadius: 2,
      }}
    >
      <Collapse
        defaultActiveKey={isSearchPanelCollapsed ? ["searchForm"] : ['1']}
        onChange={(activeKeys) => {
          const normalizedKeys = Array.isArray(activeKeys) ? activeKeys : [activeKeys];
          setIsSearchPanelCollapsed(!normalizedKeys.includes("searchForm"));
        }}
      >
        <Panel header="Search Order" key="searchForm">
          <form
            style={{ gap: "10px", alignItems: "flex-end" }}
            onSubmit={handleSearchSubmit}
          >
            <Row
              style={{ gap: "10px", alignItems: "flex-end" }}
              gutter={[10, 10]}
            >
              <FormTextField
                colSpan={6}
                label="Phone No"
                size={INPUT_SIZE}
                name="CustomerPhone"
                onChange={handleSearchFieldChange}
                isNumber="true"
                type="text"
              />

              <FormTextField
                colSpan={6}
                label="Order No"
                size={INPUT_SIZE}
                name="OrderNumber"
                onChange={handleSearchFieldChange}
                isNumber="true"
                type="text"
              />

              <FormTextField
                colSpan={6}
                label="Customer Name"
                size={INPUT_SIZE}
                name="CustomerName"
                onChange={handleSearchFieldChange}
              />

              <FormSelect
                colSpan={5}
                listItem={orderStatusList}
                idName="OrderStatusId"
                valueName="OrderStatus"
                size={INPUT_SIZE}
                name="StatusId"
                label="Status"
                value={searchFields.StatusId || ""}
                onChange={handleSelectChange}
              />

              <FormSelect
                colSpan={5}
                listItem={branchList}
                idName="BranchId"
                valueName="BranchName"
                size={INPUT_SIZE}
                name="BranchId"
                label="Branch"
                value={searchFields.BranchId || ""}
                onChange={handleSelectChange}
              />

              <FormSelect
                colSpan={5}
                listItem={areaList}
                idName="AreaId"
                valueName="AreaName"
                size={INPUT_SIZE}
                name="AreaId"
                label="Area"
                value={searchFields.AreaId || ""}
                onChange={handleSelectChange}
              />

              <FormSelect
                colSpan={5}
                listItem={orderSourceList}
                idName="OrderSourceId"
                valueName="OrderSource"
                size={INPUT_SIZE}
                name="OrderSourceId"
                label="Order Source"
                value={searchFields.OrderSourceId || ""}
                onChange={handleSelectChange}
              />

              <FormTextField
                type="date"
                style={{ width: "100%" }}
                label="Date From"
                name="DateFrom"
                placeholder="MM/DD/YYYY"
                ref={dateFromRef}
                onChange={(dateValue) => {

                  setSearchFields({
                    ...searchFields,
                    DateFrom: dateValue.value,
                  });
                }}
              />

              <FormTextField
                type="date"
                style={{ width: "100%" }}
                label="Date To"
                name="DateTo"
                placeholder="MM/DD/YYYY"
                ref={dateToRef}
                onChange={(dateValue) => {

                  setSearchFields({
                    ...searchFields,
                    DateTo: dateValue.value,
                  });
                }}
              />

              <FormButton
                title="Search"
                type="primary"
                icon={loading ? <LoadingOutlined /> : <SearchOutlined />}
                htmlType="submit"
              />
            </Row>
          </form>
          <br />
          <div className="flex justify-between items-center w-full mb-4">
            <ExportExcelButton dataSource={filteredData} />


          </div>
        </Panel>
      </Collapse>

      <br />

      {orderStatusList.length > 0 && (
        <nav className="w-full mb-4 flex justify-center">
          <div className="flex gap-2 overflow-x-auto px-2 py-2 bg-gray-100 rounded-full shadow-sm max-w-full scrollbar-hide">
            <button
              key={999}
              className={`min-w-max px-4 py-2 rounded-full font-medium text-sm transition-colors duration-200 ${isAllOrders
                ? "bg-[#017971] text-white"
                : "bg-white text-gray-700 hover:bg-[#017971] hover:text-white"
                }`}
              onClick={() => {
                setIsAllOrders(true);
                setFilteredData(allOrders);
              }}
            >
              All Orders
            </button>

            {orderStatusList
              .filter((status) => status.OrderStatus !== "Pending")
              .map((status) => {
                const isActive =
                  selectedOrderStatus === status.OrderStatus && !isAllOrders;
                const count = getOrderStatusCount(status.OrderStatusId);
                const statusColor = getStatusColor(status.OrderStatus);
                // const buttonBgColor = isActive && statusColor ? statusColor : (isActive ? "#017971" : "white");
                const buttonBgColor = statusColor ?? "white";
                const buttonTextColor = isActive && statusColor ? "#000000" : (isActive ? "white" : "#374151");

                return (
                  <button
                    key={status.OrderStatusId}
                    className="relative min-w-max px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200"
                    style={{
                      backgroundColor: buttonBgColor,
                      color: buttonTextColor,
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive && statusColor) {
                        e.currentTarget.style.backgroundColor = statusColor;
                        e.currentTarget.style.color = "#000000";
                      } else if (!isActive) {
                        e.currentTarget.style.backgroundColor = "#017971";
                        e.currentTarget.style.color = "white";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = "white";
                        e.currentTarget.style.color = "#374151";
                      }
                    }}
                    onClick={() => {
                      handleTabChange(status.OrderStatusId);
                      setSelectedOrderStatus(status.OrderStatus);
                    }}
                  >
                    {status.OrderStatus}
                    {count > 0 && (
                      <span
                        className={`absolute -top-2 -right-2 flex items-center justify-center rounded-full text-white text-xs font-bold bg-[#017971] shadow-md ${count > 99 ? "w-[26px] h-[26px]" : "w-[20px] h-[20px]"
                          }`}
                      >
                        {count > 99 ? "99+" : count}
                      </span>
                    )}
                  </button>
                );
              })}
          </div>
        </nav>
      )}


      <Table
        loading={loading}
        columns={columns}
        expandable={{
          expandedRowRender: (item) => (
            <DetailPopover data={popoverData[item.OrderMasterId]} />
          ),
          rowExpandable: (record) => record.name !== "Not Expandable",
          onExpand: (expanded, item) => getDetail(item),
        }}
        dataSource={filteredData}
        rowKey="RowNum"
        onRow={(record) => ({
          style: getRowStyle(record),
        })}
      />
    </div>

  );
}

export default Podms;